/* theme.js - Melauno Aesthetics Shopify Theme */

document.addEventListener('DOMContentLoaded', function () {

  // =====================
  // NAVBAR SCROLL
  // =====================
  const navbar = document.querySelector('.navbar');

  function updateNavbar() {
  const scrolled = window.scrollY > 40;
  navbar.classList.toggle('scrolled', scrolled);
  navbar.classList.toggle('navbar--dark', scrolled);

  const whiteLogo = document.querySelector('.white-logo');
  const darkLogo = document.querySelector('.dark-logo');
  if (whiteLogo && darkLogo) {
    whiteLogo.style.display = scrolled ? 'none' : 'block';
    darkLogo.style.display = scrolled ? 'block' : 'none';
  }
}

  updateNavbar();
  window.addEventListener('scroll', updateNavbar);

  // =====================
  // MOBILE MENU
  // =====================
  const hamburger = document.querySelector('.navbar__hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.contains('open');
      mobileMenu.classList.toggle('open');
      hamburger.querySelector('.icon-open').style.display = isOpen ? 'block' : 'none';
      hamburger.querySelector('.icon-close').style.display = isOpen ? 'none' : 'block';
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.querySelector('.icon-open').style.display = 'block';
        hamburger.querySelector('.icon-close').style.display = 'none';
      });
    });
  }

  // =====================
  // SCROLL ANIMATIONS
  // =====================
  const animatedEls = document.querySelectorAll('.fade-up, .fade-left, .fade-right');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animatedEls.forEach(function (el) { observer.observe(el); });
  } else {
    animatedEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // =====================
  // TESTIMONIALS CAROUSEL
  // =====================
  const slides = document.querySelectorAll('.testimonials__slide');
  const dots = document.querySelectorAll('.testimonials__dot');
  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('active');
    dots[current].classList.add('active');
  }

  const prevBtn = document.querySelector('.testimonials__nav-btn--prev');
  const nextBtn = document.querySelector('.testimonials__nav-btn--next');

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });

  if (slides.length > 0) {
    setInterval(function () { goTo(current + 1); }, 6000);
  }

});